<template>
  <div class="announcement">Please note that the loyalty shop is currently paused. We'll keep you updated.</div>
</template>

<script>
import { mapGetters } from 'vuex'
import AppHeader from '@/components/AppHeader'
import AppMain from '@/components/AppMain'
import AppGifts from '@/components/AppGifts'
import AppQuests from '@/components/AppQuests'
import AppBadges from '@/components/AppBadges'
import AppPopup from '@/components/AppPopup'
import AppPointTransfer from '@/components/AppPointTransfer'
import AppPointTransferNotifier from '@/components/AppPointTransferNotifier'

export default {
  data () {
    return {
      isMounted: false
    }
  },
  props: {
    loading: Boolean,
    default: false
  },
  components: {
    AppHeader,
    AppMain,
    AppGifts,
    AppQuests,
    AppBadges,
    AppPopup,
    AppPointTransfer,
    AppPointTransferNotifier
  },
  computed: {
    ...mapGetters(['remoteConfig', 'isInited']),
    // Menu items
    menu () {
      if (!this.isMounted) return
      return [
        {
          alias: 'profile',
          name: 'Profile',
          ref: this.$refs['profile']
        },
        {
          alias: 'actions',
          name: 'Actions for points',
          ref: this.$refs['actions']
        },
        {
          alias: 'gifts',
          name: 'Rewards',
          ref: this.$refs['gifts']
        },
        {
          alias: 'history',
          name: 'History',
          emit: {
            'event': 'popup',
            'param': 'history'
          },
          noScroll: true
        },
        {
          alias: 'contactus',
          name: 'Contact us',
          href: 'mailto:loyalty@luxoft.com',
          target: '_blank'
        }
      ]
    },
    accessDenied () {
      return !this.$store.getters['currentTags'] || this.$store.getters['currentTags'].find(tag => tag.tag === 'No Access')
    }
  },
  methods: {
    onMenuClick (item) {
      if (item.ref) {
        let rect = item.ref.$el && item.ref.$el.getBoundingClientRect()
        let headerHeight = this.$refs['header'].$el.querySelector('.header')
          .clientHeight
        let offsetY = rect.top + window.pageYOffset - headerHeight
        if (offsetY !== 0) {
          window.scrollTo(rect.left, offsetY)
        }
      }
    }
  },
  mounted () {
      this.isMounted = true;
  }
}
</script>

<style lang="scss">
// @import "./assets/styles/components/normalize.min.css";
// @import "./assets/styles/main";
</style>
